import cs from 'classnames';
import dayjs from 'dayjs';
import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import Radio from '../../../../components/Radio';
import { getActiveLanguage } from '../../../../utils/handleLanguage';
import { LANGUAGE_LIST } from '../../const';
import classes from './style.module.scss';

export default function FooterTop({ socialMediaAccounts }) {
  const { t, i18n } = useTranslation();

  const handleChangeLanguage = (e) => {
    const language = e?.target?.value;
    i18n.changeLanguage(language);
    dayjs.locale(language);
  };

  return (
    <div className={classes.container}>
      <div className={classes.topElementContent}>
        <div className={classes.topElementContentElement}>
          <span className={classes.contentTitle}>{t('footer_language')}</span>
          {LANGUAGE_LIST.map((language) => (
            <div key={language.value} className={classes.languageRadioButton}>
              <Radio
                checked={getActiveLanguage() === language.value}
                onChange={handleChangeLanguage}
                label={t(language.translationId)}
                value={language.value}
              />
            </div>
          ))}
        </div>
        <div className={classes.topElementContentElement}>
          <span className={cs(classes.contentTitle, classes.socialMediaTitle)}>
            {t('footer_social_media_accounts')}
          </span>
          {socialMediaAccounts.map(({ url, icon }) => (
            <a
              key={url}
              href={url}
              target="_blank"
              rel="noopener noreferrer"
              className={classes.socialMediaIcon}
            >
              <img src={icon} alt={url} />
            </a>
          ))}
        </div>
      </div>
    </div>
  );
}

FooterTop.propTypes = {
  socialMediaAccounts: PropTypes.arrayOf(PropTypes.any).isRequired
};
